import { render, staticRenderFns } from "./QuickFilter.vue?vue&type=template&id=23b7848d&scoped=true"
import script from "./QuickFilter.vue?vue&type=script&lang=ts"
export * from "./QuickFilter.vue?vue&type=script&lang=ts"
import style0 from "./QuickFilter.vue?vue&type=style&index=0&id=23b7848d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b7848d",
  null
  
)

export default component.exports